module.exports = __webpack_public_path__ + "static/cinzel-variablefont_wght-webfont-707f2939bb3b0daf7d376e36b541c62f.woff2";